import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Nav, Tab, Row, Col, Button } from 'react-bootstrap';
import { IndexLinkContainer, LinkContainer } from 'react-router-bootstrap';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import { BsFillArrowRightCircleFill, BsFillArrowLeftCircleFill } from 'react-icons/bs';

import './publicationCatMenu.module.css';

const PublicationCatMenu = props => {

    const { publicationCategory } = useSelector(state => state.all)

    const LeftArrow = () => {
        const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);

        return (
            !isFirstItemVisible ?
            <Button className='left-btn' disabled={isFirstItemVisible} onClick={() => scrollPrev()}>
                <BsFillArrowLeftCircleFill />
            </Button> : null
        );
    }

    const RightArrow = () => {
        const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);

        return (
            !isLastItemVisible ?
            <Button className='right-btn' disabled={isLastItemVisible} onClick={() => scrollNext()}>
                <BsFillArrowRightCircleFill />
            </Button> : null
        );
    }

    return (
        <Row>
            <Col sm={12} className="px-0">
                <div className="publication-cat-menu" styleName="publication-cat-menu">
                    <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} >
                        <Nav.Item className='ml-2'>
                            <IndexLinkContainer to="/publications">
                                <Nav.Link className="publication-cat-link" styleName="publication-cat-link">All</Nav.Link>
                            </IndexLinkContainer>
                        </Nav.Item>
                        {publicationCategory && publicationCategory.length > 0 && publicationCategory.map((item, index) => (
                            <Nav.Item className='ml-2' key={`pub_cat_menu_item_${index + 1}`}>
                                <IndexLinkContainer to={`/publications/${item.name}`} eventKey={`/publications/${item.name}`}>
                                    <Nav.Link className="publication-cat-link" styleName="publication-cat-link">{item.name}</Nav.Link>
                                </IndexLinkContainer>
                            </Nav.Item>
                        ))}
                    </ScrollMenu>
                </div>
            </Col>
        </Row>
    )
}

export default PublicationCatMenu;